<template>
    
    <HeaderMaiora v-if="section == 'maiora' && pageItem" :gamma="gamma" @updateFiles="updateFiles" @goToPage="goToPage" @collapse="collapse" />
    <HeaderAbyachts v-if="section == 'ab-yachts' && pageItem" :gamma="gamma" @updateFiles="updateFiles" @goToPage="goToPage" @collapse="collapse" />

    <div id="result" class="d-none"></div>

</template>

<script>
import HeaderAbyachts from '../headers/HeaderAbyachts.vue'
import HeaderMaiora from '../headers/HeaderMaiora.vue'

export default {
    name: 'HeaderYachts',
    props: ['section'],
    emits: ['updateFiles', 'goToPage', 'collapse'],
    computed: {
        pageItem() {
            return this.$store.getters['filelist/pagesFromSection'](this.section)
        },
        gamma() {
            if (!this.pageItem) return false
            return this.pageItem.gamma.filter((item) => !item.parentId)
        },
        needtoupdate() {
            return this.$store.getters['filelist/needtoupdate']
        },
        filesMissing() {
            return this.$store.getters['filelist/filesMissing']
        },
    },
    methods: {
        async updateFiles() {
            await this.$store.dispatch('filelist/getPageItems', true).then((response) => {
                //console.log('response', response)
                if (response.error) {
                    if (response.error == "User not found!") this.$store.dispatch('login/logout')
                    return false
                }
                if (this.needtoupdate) {
                    //console.log("needtoupdate")
                    this.downloadFiles()
                }
            })
        },
        async downloadFiles() {
            // resetto variabili
            this.$store.dispatch('filelist/resetCounters')
            // avvio download
            let appPath = this.$store.getters.appPath
            let publicPath = this.$store.getters.publicPath
            for (let i = 0; i < this.filesMissing.length; i++) {
                let jsonPath = this.filesMissing[i]
                let filePath = jsonPath.substr(7)
                let localpath = appPath + filePath
                let remotepath = publicPath + filePath
                await this.$store.dispatch('filelist/downloadFile', {
                    filePath: jsonPath,
                    localPath: localpath,
                    remotePath: remotepath
                })
                .then((response) => {
                    return(response)
                })
                .catch((error) => {
                    console.log(error);
                    //return false
                });
            }
        },
        goBack() {
            this.$store.dispatch('setSection', null)
        },
        goToPage(id) {
            this.hideCollapsed()
            this.$store.dispatch('goToPage', id)
        },
        hideCollapsed() {
            let collapseList = document.getElementsByClassName('collapse')
            for (const el of collapseList) {
                el.classList.remove('show')
            }
        },
        collapse(id) {
            let box = document.getElementById('collapse-'+ id)
            box.classList.toggle('show')
        },
    },
    mounted() {
        this.$nextTick(function () {
            //chiudo tutti i menu
            document.addEventListener("click", (event) => {
                const target = event.target
                let menuItem = target.closest('nav')
                if (!menuItem) {
                    this.hideCollapsed()
                }
            })
        });
    },
    components: {
        HeaderMaiora,
        HeaderAbyachts,
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
